const config = {
    baseUrl: process.env.REACT_APP_MODE === 'production' ? process.env.REACT_APP_PROD_BASE_URL : process.env.REACT_APP_DEV_BASE_URL,
    baseUrlFiles: process.env.REACT_APP_MODE === 'production' ? process.env.REACT_APP_PROD_BASE_URL_FILES : process.env.REACT_APP_DEV_BASE_URL_FILES,
    baseUrlFilesContract: process.env.REACT_APP_MODE === 'production' ? process.env.REACT_APP_PROD_BASE_URL_FILES_CONTRACT : process.env.REACT_APP_DEV_BASE_URL_FILES_CONTRACT,
}

module.exports = { config }